import { useLocation, useNavigate } from "react-router-dom"
import {TbArrowBack} from 'react-icons/tb'
import {MdAddCircle, MdArrowDropDown, MdArrowDropUp, MdCheckBox, MdCheckBoxOutlineBlank, MdContentCopy, MdDelete, MdRemoveRedEye, MdSave, MdShare} from 'react-icons/md'
import { useContext, useEffect, useState } from "react"
import Modal from "../../Components/Modal"
import { getEventDoc, getEventsDoc, updateEventFormDoc } from "../../Requests/firebaseFirestore"
import { uploadFormBanner } from "../../Requests/firebaseStorage"
import { toDataURL } from "qrcode"
import UserContext from "../../Context/UserContext"
import { useCallback } from "react"
export default function EventFormPage(){
  const location = useLocation()
  const navigate = useNavigate()
  const defaultFormInput = {type:'', title:'', options:[], required:false}
  const [formInputs, setFormInputs] = useState([])
  const [formModal, setFormModal] = useState(false)
  const [saved, setSaved] = useState(true)
  const [errors, setErrors] = useState([])
  const [errorModal, setErrorModal] = useState(false)
  const [shareModal, setShareModal] = useState(false)
  const [footer, setFooter] = useState({})
  const [qrCode, setQrCode] = useState('')
  const [events, setEvents] = useState([])
  const [copyModal, setCopyModal] = useState(false)
  const [copyEvent, setCopyEvent] = useState('')
  const [coping, setCoping] = useState(false)
  const {url} = useContext(UserContext)
  const setFormInputList = useCallback(
    async () => {
      const res = await getEventDoc(location.state.id)
      if(res.form.length>0){
        setFormInputs([...res.form])
      }
      if(res.footer){
        setFooter({imageUrl:res.footer})
      }
    },[location]) 
  useEffect(()=>{
    setFormInputList()
  },[location])

  useEffect(()=>{
    setSaved(false)
  },[formInputs])
  
  const handleErrorModal = (errors) => {
    if(errors){
      setErrors(errors)
    }else{
      setErrors([])
    }
    setErrorModal(!errorModal)
  }

  const handleCopyModal = async () =>{
    setCopyEvent('')
    if(events.length===0){
      let res = await getEventsDoc()
      res = res.filter(evnt=>evnt.id!==location.state.id)
      setEvents([...res])
    }
    setCopyModal(!copyModal)
  }

  const handleCopySubmit = async (e) => {
    e.preventDefault()
    setCoping(true)
    await updateEventFormDoc(location.state.id, events[copyEvent].form, events[copyEvent].footer)
    await setFormInputList()
    setCopyModal(false)
    setCoping(false)
  }

  const checkForFormErrors = () => {
    let errorList = []
    let titles = []
    formInputs.forEach((formInput, index)=>{
      titles = [...titles, formInput.title]
      switch (formInput.type) {
        case '':
          errorList = [...errorList, `campo ${index+1}: No tiene tipo`]
          break;
        case 'title':
          if(formInput.title==='')
          errorList = [...errorList, `campo ${index+1}: No tiene titulo`]
          break;
        case 'banner':
          if((formInput.localImage===''||formInput.localImage===undefined)&&(formInput.imageUrl===''||formInput.imageUrl===undefined)){                         //agregar imageurl
            errorList = [...errorList, `campo ${index+1}: No tiene imagen`]
          }
          if((formInput.file)&&(formInput.file.type!=='image/png'&&formInput.file.type!=='image/jpeg'&&formInput.file.type!=='image/jpg')){
            errorList = [...errorList, `campo ${index+1}: Formato de archivo inválido, solo se aceptan .png, .jpg y .jpeg`]
          }
          break;
        case 'text':
          if(formInput.title===''){                    
            errorList = [...errorList, `campo ${index+1}: No tiene titulo`]
          }
          break;
        case 'textarea':
          if(formInput.title===''){                       
            errorList = [...errorList, `campo ${index+1}: No tiene titulo`]
          }
          break;
        case 'email':
          if(formInput.title===''){                       
            errorList = [...errorList, `campo ${index+1}: No tiene titulo`]
          }
          break;
        case 'select':
          if(formInput.title===''){                         
            errorList = [...errorList, `campo ${index+1}: No tiene titulo`]
          }
          if(formInput.options.length===0){
            errorList = [...errorList, `campo ${index+1}: No tiene opciones`]
          }
          if(formInput.options.some((option, i)=>formInput.options.indexOf(option)!==i)){
            errorList = [...errorList, `campo ${index+1}: Hay opciones repetidas`]
          }
          break;
        case 'checkbox':
          if(formInput.title===''){                         
            errorList = [...errorList, `campo ${index+1}: No tiene titulo`]
          }
          if(formInput.options.length===0){
            errorList = [...errorList, `campo ${index+1}: No tiene opciones`]
          }
          if(formInput.options.some((option, i)=>formInput.options.indexOf(option)!==i)){
            errorList = [...errorList, `campo ${index+1}: Hay opciones repetidas`]
          }
          break;
        case 'radio':
          if(formInput.title===''){                         
            errorList = [...errorList, `campo ${index+1}: No tiene titulo`]
          }
          if(!formInput.maxTag||!formInput.minTag){
            errorList = [...errorList, `campo ${index+1}: Tiene campos vacíos`]
          }
          break;
        default:
          break;
      }
    })

    if(titles.some((option, i)=>titles.indexOf(option)!==i)){
      errorList = [...errorList, `Hay campos con el mismo título`]
    }
    if((footer.localImage===''||footer.localImage===undefined)&&(footer.imageUrl===''||footer.imageUrl===undefined)){
      errorList = [...errorList, `footer: No tiene imagen`]
    }
    
    return errorList
  }

  const handleNewInput = () =>{
    setFormInputs([...formInputs, defaultFormInput])
  }

  const handleInputChange = (e, index) => {
    let newVal;
    switch (e.target.value) {
      case 'true':
        newVal = true
        break;
      case 'false':
        newVal = false
        break;
      default:
        newVal = e.target.value
        break;
    }
    let inputs = formInputs
    inputs[index] = {...inputs[index], [e.target.name]:newVal}
    if(inputs[index].type!=='select'&&inputs[index].type!=='checkbox'&&inputs[index].type!=='radio'){
      inputs[index].options = []
    }
    setFormInputs([...inputs])
  }

  const handleNewOption = (e,index) =>{
    e.preventDefault()
    if(e.target.childNodes[1].value!==''){
      let inputs = formInputs
      inputs[index].options.push(e.target.childNodes[1].value)
      setFormInputs([...inputs])
      e.target.childNodes[1].value=''
    }
  }

  const handleDeleteOption = (index, i) => {
    let inputs = formInputs
    inputs[index].options.splice(i, 1)
    setFormInputs([...inputs])
  }

  const handleDeleteInput = (index) => {
    let inputs = formInputs
    inputs.splice(index,1)
    setFormInputs([...inputs])
  }

  const handleModal = () => {
    const errors = checkForFormErrors()
    if(errors.length === 0){
      setFormModal(!formModal)
    }else{
      handleErrorModal(errors)
    }
  }

  const handleSaveForm = async () => {
    const errors = checkForFormErrors()
    if(errors.length===0){
      let inputs = formInputs
      for(const [index, input] of formInputs.entries()){        
        if(input.type==='banner'){
          if(input.file){
            let url = await uploadFormBanner(input.file, location.state.id, `banner-${location.state.id}-${index}`, input.file.type)
            inputs[index]= {...inputs[index], imageUrl: url}

          }
          delete inputs[index].file
          delete inputs[index].localImage
        }
      }
      let footerUrl
      if(footer.file){
        footerUrl = await uploadFormBanner(footer.file, location.state.id, `footer-${location.state.id}`, footer.file.type)
      }
      setSaved(true)
      location.state.form = [...inputs]
      await updateEventFormDoc(location.state.id, inputs, footerUrl)
      await setFormInputList()
      
    }else{
      handleErrorModal(errors)
    }
  }

  const handleImage = (e, index) => {
    const newVal = URL.createObjectURL(e.target.files[0])
    let inputs = formInputs
    inputs[index] = {...inputs[index], localImage:newVal, file:e.target.files[0]}
    setFormInputs([...inputs])
  }

  const generateQr = async (text) => {
    try {
      const res = await toDataURL(text)
      return res
    } catch (error) {
    }
  }

  const handleOrderOptions = (i) => {
    let oldForm = [...formInputs]
    oldForm[i].options = formInputs[i].options.sort()
    setFormInputs([...oldForm])
  }

  const handleShareModal = async () =>{
    const res = await generateQr(`${url}/invitationform/${location.state.id}`)
    setQrCode(res)
    setShareModal(!shareModal)
  }

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text)
  }

  const handleFooterInput = (e) => {
    const newVal = URL.createObjectURL(e.target.files[0])
    setFooter({...footer, localImage:newVal, file:e.target.files[0]})
  }

  const displayCustomInput = (input, index) => {
    let output = <></>
          let i = index
          switch (input.type) {
            case 'title':
              output = <div className="input-holder w-[75%]">
                <h1 className="font-semibold text-lg" key={index}>{input.title}</h1>
                {
                  input.subtitle && input.subtitle !== ''?
                  <h1 className="font-normal my-[5px]">{input.subtitle}</h1>
                  :<></>
                }
                </div>
              break;
            case 'banner':
              output=<><img className="rounded-[10px]" src={input.localImage?`${input.localImage}`:`${input.imageUrl}`} alt="banner"  key={index}/></>
              break;
              case 'text':
                output = <>
                {input.title.length>40?<label className="font-semibold w-[75%] block mx-auto" htmlFor={`input-preview-${index}`}>{input.title}</label>:''}
                <div className="input-holder w-[75%]" key={index}>
                <input type='text' name={input.label} id={`input-preview-${index}`} required></input>
                {input.title.length<=40?<label htmlFor={`input-preview-${index}`}>{input.title}</label>:''}
              </div></>
              break;
              case 'email':
                output = <>
                {input.title.length>40?<label className="font-semibold w-[75%] block mx-auto" htmlFor={`input-preview-${index}`}>{input.title}</label>:''}
                <div className="input-holder w-[75%]" key={index}>
                <input type='email' name={input.label} id={`input-preview-${index}`} required></input>
                {input.title.length<=40?<label htmlFor={`input-preview-${index}`}>{input.title}</label>:''}
              </div></>
              break;
              case 'textarea':
                output = <>
                {input.title.length>40?<label className="font-semibold w-[75%] block mx-auto" htmlFor={`input-preview-${index}`}>{input.title}</label>:''}
                <div className="input-holder w-[75%]" key={index}>
                <textarea name={input.label} id={`input-preview-${index}`} required></textarea>
                {input.title.length<=40?<label htmlFor={`input-preview-${index}`}>{input.title}</label>:''}
              </div></>
              break;
              case 'select':
                output = <>
                {input.title.length>40?<label className="font-semibold w-[75%] block mx-auto" htmlFor={`input-preview-${index}`}>{input.title}</label>:''}
                <div className="input-holder w-[75%]" key={index}>
                <select type='text' name={input.label} id={`input-preview-${index}`} required>
                  {input.options.map((option, index) => {
                    return(
                      <option value={option} key={index}>{option}</option>
                    )
                  })}
                </select>
                {input.title.length<=40?<label htmlFor={`input-preview-${index}`}>{input.title}</label>:''}
              </div></>
              break;
              
              case 'checkbox':
                output = <><div className="input-holder w-[75%]" key={index}>
                <h1 className="py-2">{input.title}</h1>
                {input.options.length===0?<span>No hay opciones</span>:<></>}
                {input.options.map((option, index) => {
                  return(
                    <div key={index} className="options-holder">
                      <input type='checkbox' name={input.label} value={option} id={`${i}-${index}`} defaultChecked={input.id!==''}></input>
                      
                    <label htmlFor={`${i}-${index}`}>
                      <span className="unselected"><MdCheckBoxOutlineBlank size={25}/></span>
                      <span className="selected"><MdCheckBox size={25}/></span>

                      {option}</label>
                    </div>
                    )
                  })}
                  </div></>
              break;
              
            case 'radio':
              let options = []
              for (let a = 1; a <= 5; a++) {
                options = [...options, <div className="flex flex-col" key={a}><label htmlFor={`${a}-${index}`} key={a}>{a}</label><input type='radio' id={`${a}-${index}`} name={index} value={a}/></div>]
              }
              options = [<span>{input.minTag}</span>, ...options, <span>{input.maxTag}</span>]
              output = <>
              <h1 className="py-2  w-[75%] mx-auto">{input.title}</h1>
              <fieldset className="input-holder w-full">
              <div className="flex justify-evenly">
                {options.map((option) =>{return(option)})}
              </div>
            </fieldset>
            </>
              break;
              default:
                break;
              }
              return <div key={index}>{output}</div>
            
  }

  const handleMoveUp = (index) => {
    let inputs = formInputs
    const toMove = formInputs[index]
    const previousPos = formInputs[index-1]
    if(previousPos){
      inputs[index] = previousPos
      inputs[index-1] = toMove
      
      setFormInputs([...inputs])
    }
  }

  const handleMoveDown = (index) => {
    let inputs = formInputs
    const toMove = formInputs[index]
    const previousPos = formInputs[index+1]
    if(previousPos){
      inputs[index] = previousPos
      inputs[index+1] = toMove
      
      setFormInputs([...inputs])
    }
  }


  return(
    <div className="container mx-auto px-4">
      <h1 className="text-stone-600 font-semibold text-xl py-2">Formulario para {location.state.title}</h1>
      <div className="table-holder">
      <table className="table-auto min-w-[700px]">
        <thead>
          <tr>
            <th colSpan='100%'>
              <div className="px-5 w-full flex items-center justify-between">
                <div className="flex gap-2">
                  <button className="light-button flex gap-2 " onClick={()=>{navigate('/organizer/events')}}><TbArrowBack size={25}/>Volver</button>
                  <button className="light-button flex gap-2" onClick={handleCopyModal}><MdContentCopy size={25}/></button>
                  <button className="light-button flex gap-2" onClick={handleShareModal}><MdShare size={25}/></button>
                </div>
                <div className="flex gap-2">
                  <button className="light-button" onClick={handleModal}><MdRemoveRedEye size={25}/></button>
                  <button className="light-button flex items-center gap-2" onClick={handleSaveForm}><MdSave size={25}/>{saved?'Guardado':'Guardar'}</button>
                </div>
              </div>
            </th>
          </tr>
          <tr>
            <th></th>
            <th>Acciones</th>
            <th>Tipo</th>
            <th colSpan='100%'>Configuración</th>
          </tr>
        </thead>
        <tbody>
          {formInputs.map((formInput, index)=>{
            let a = index
            let output = <></>
            switch (formInput.type) {
              case '':
                output=<h1>Seleccione un tipo</h1>
                break;
              case 'banner':
                output=<div className="flex gap-2" key={index}>
                <input type="file" accept=".png, .jpeg, .jpg" name="localImage" onChange={(e)=>{handleImage(e, index)}}/>
                {formInput.imageUrl?
                <a href={formInput.imageUrl} target='_blank' className="flex items-center whitespace-nowrap action-button my-1 border-[#9F2348] text-[#9F2348] hover:text-white hover:bg-[#9F2348] active:bg-[#5B2966] duration-150">Ver imagen actual</a>
                :
                <></>}
                </div>
                break;
              case 'title':
                output=<div key={index} className='flex gap-2'>
                  <input type="text" name="title" id={index} value={formInput.title} onChange={(e)=>{handleInputChange(e, index)}} required placeholder="Título"/>
                  <input type="text" name="subtitle" value={formInput.subtitle} onChange={(e)=>{handleInputChange(e, index)}} placeholder='subtítulo'/>
                </div>
                break;
                case 'radio':
                  output = <div className="flex gap-2 items-center" key={index}>
                  <input type="text" name="title" id={index} value={formInput.title} onChange={(e)=>{handleInputChange(e, index)}} required/>
                  <span>min:</span>
                  <input type="text" name="minTag" value={formInput.minTag} onChange={(e)=>{handleInputChange(e, index)}} required/>
                  <span>max:</span>
                  <input type="text" name="maxTag" value={formInput.maxTag} onChange={(e)=>{handleInputChange(e, index)}} required/>
                  </div>
                  break;
              default:
                output=<div className="flex gap-2 items-center" key={index}>
                  <div className="flex flex-col gap-y-3 w-full">
                <input form={index} type="text" name="title" id={index} value={formInput.title} onChange={(e)=>{handleInputChange(e, index)}} required readOnly={formInput.default===true}/>
              <div className="flex  gap-3 justify-center">
                {formInput.type==='select'||formInput.type==='checkbox'?
                <>
                {formInput.default?<>
                <span>Opciones:</span>
                  <div className="flex  items-center divide-x-2">
                  {formInput.options.map((option,index)=>{
                    return<span className="px-1" key={index} >{option}</span>
                  })}
                </div>
                </>:<>
                <div className="flex items-center gap-3">
                <div className="flex flex-col gap-1">

                <form className="flex justify-center gap-3 items-center" onSubmit={(e)=>{handleNewOption(e,index)}}>
                  <button className="text-stone-400" disabled={(formInput.type!=='select'&&formInput.type!=='checkbox'&&formInput.type!=='radio')}><MdAddCircle size={25}/></button>
                  <input className="w-[150px] h-fit" type="text" placeholder="Opciones" disabled={(formInput.type!=='select'&&formInput.type!=='checkbox'&&formInput.type!=='radio')}/>
                </form>
                  <button type="button" className="bg-stone-300 w-fit py-1 px-2 rounded-lg mx-auto" onClick={()=>handleOrderOptions(a)}>Ordenar</button>
                </div>
                <div className="flex flex-wrap">

                  {formInput.options.map((option,index)=>{
                    return<span className="px-1 hover:line-through cursor-pointer bg-stone-200 rounded-[10px] m-1" key={index} onClick={()=>{handleDeleteOption(a,index)}}>{option}</span>
                  })}
                  </div>
                </div>
                  </>
                  }
                  </>:<></>}
              </div>
                  </div>
              <div className="flex flex-col gap-2">
                <label htmlFor={`required-${index}`}>Obligatorio? </label>
                <input type="checkbox" name="required" id={`required-${index}`} onChange={(e)=>{handleInputChange(e, index)}} value={!formInput.required} checked={formInput.required} disabled={formInput.default===true}/>
              </div>
                </div>
                break;
            }
            return(
            <tr key={index}>
              <td>
                <span className="text-stone-400">{index+1}</span>
              </td>
              <td>
                <div className="flex gap-2 items-center mr-2">
                <div className="flex flex-col">
                  <button className="h-fit" onClick={()=>{handleMoveUp(index)}}><MdArrowDropUp size={20}/></button>
                  <button className="h-fit" onClick={()=>{handleMoveDown(index)}}><MdArrowDropDown size={20}/></button>
                </div>
                {formInput.default===true?<>-</>:
                <button className="action-button h-fit border-red-500 text-red-500 hover:text-white hover:bg-red-500 active:bg-red-700 duration-150" onClick={()=>{handleDeleteInput(index)}}><MdDelete size={25}/></button>
                }
                </div>
              </td>
              <td>
              <form id={index}>
                <select name="type" className="min-w-[125px]" id={index} value={formInput.type} onChange={(e)=>{handleInputChange(e, index)}} required disabled={formInput.default===true}>
                  <option value="" disabled hidden></option>
                  <option value="title">Título</option>
                  <option value="banner">Banner</option>
                  <option value="text">Texto</option>
                  <option value="textarea">Párrafo</option>
                  <option value="email">Email</option>
                  <option value="select">Desplegable</option>
                  <option value="checkbox">Casillas</option>
                  <option value="radio">Escala lineal</option>
                </select>
                </form>
              </td>
              <td className="pl-3">
                {output}
              </td>
          </tr>
          )})}
          <tr>
            <td colSpan='100%' className="  "><button onClick={handleNewInput} className="flex w-fit mx-auto gap-2 duration-200 text-stone-500 bg-stone-200 py-2 px-3 rounded-[10px] hover:outline hover:outline-1 hover:border-stone-400 active:bg-stone-300"><MdAddCircle size={25}/>Agregar campo</button></td>
          </tr>
          <tr>
            <td><span className="text-stone-400">{formInputs.length +1}</span></td>
            <td>-</td>
            <td>
            <select name="type" value={'checkbox'} disabled>
                  <option value="" disabled hidden></option>
                  <option value="title">Título</option>
                  <option value="banner">Banner</option>
                  <option value="text">Texto</option>
                  <option value="textarea">Párrafo</option>
                  <option value="email">Email</option>
                  <option value="select">Desplegable</option>
                  <option value="checkbox">Casillas</option>
                  <option value="radio">Escala lineal</option>
                </select>
            </td>
            <td colSpan='100%'>
              <span>Solicitar reuniones</span>
            </td>
          </tr>
          <tr>
            <td colSpan='100%'>
              <div className="flex items-center px-6 gap-4 justify-center">
                <span>Footer</span>
                <input type="file"  className="max-w-[500px]" onChange={handleFooterInput}  accept=".png, .jpeg, .jpg"/>
                {footer.imageUrl?
                <a href={footer.imageUrl} target='_blank' className="flex items-center whitespace-nowrap action-button my-1 border-[#9F2348] text-[#9F2348] hover:text-white hover:bg-[#9F2348] active:bg-[#5B2966] duration-150">Ver imagen actual</a>
                :<></>}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      </div>
      <Modal isActive={formModal} handle={handleModal} title='Vista previa'>
        <form className="flex flex-col gap-y-4 px-4 " onSubmit={(e)=>{e.preventDefault()}}>

        {formInputs.map((input, index) => {
          return displayCustomInput(input, index)
          })}
          <button className="send-btn">Enviar</button>
            <img src={footer.localImage?footer.localImage:footer.imageUrl} alt='footer' className='rounded-[10px]'/>
            </form>
      </Modal>
      <Modal isActive={errorModal} handle={handleErrorModal} title='Por favor corrija los errores'>
            <div  className="flex flex-col gap-4 px-8">
              {errors.map((error, index) => {
                return<span key={index}>{error}</span>
              })}
            </div>
      </Modal>
      <Modal isActive={shareModal} handle={handleShareModal} title='Compartir formulario de invitación'>
        <div className="w-[75%] mx-auto flex flex-wrap items-center justify-center">
          <div className="flex flex-col justify-center items-center gap-4">
            <button onClick={(e)=>{handleCopy(`${url}/invitationform/${location.state.id}`)}} className='flex hover:underline' id='copy-invitation'><MdContentCopy size={25}/>copiar link</button>
            <a href={qrCode} download='invitation-qr.png' className="send-btn">descargar QR</a>
          </div>
          <img src={qrCode} alt="qr code" className="mx-auto"/>
        </div>
      </Modal>
      <Modal isActive={copyModal} handle={handleCopyModal} title='Copiar formulario de otro evento'>
        <form className="flex flex-col gap-4 justify-center" onSubmit={handleCopySubmit}>

        <div className="input-holder w-[75%]">
          <select name="" id="form-copy-event" value={copyEvent||''} onChange={(e)=>{setCopyEvent(e.target.value)}} required>
            <option value="" disabled hidden></option>
            {events.map((event, index)=>{return(
              <option value={index} key={index}>{event.name}</option>
              )})}
          </select>
          <label htmlFor="form-copy-event">Seleccione un evento</label>
        </div>
        <button className="send-btn" disabled={coping}>{coping?'Copiando':'Copiar formulario'}</button>
        </form>
        {copyEvent!==''?
        <>
          <form className="flex flex-col gap-y-4 px-4 mt-4">

          {events[copyEvent].form.map((input, index) => {
            return displayCustomInput(input, index)
            })}
              <img src={events[copyEvent].footer} alt='footer' className='rounded-[10px]'/>
              </form>
        </>
        :<></>}
      </Modal>
    </div>
  )
}